import { render, staticRenderFns } from "./IconDeleteChip.vue?vue&type=template&id=0d0b119a&functional=true"
import script from "./IconDeleteChip.vue?vue&type=script&lang=js"
export * from "./IconDeleteChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports